import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../ts/ServerApi/types/IGetItemsResult';
import { IMaxDownstreamDatasources, IMaxDownstreamWorkbooks} from '../../../../ts/ServerApi/types/IMaxDownstreamConnections';
import { IDatabase } from '../../types/IDatabase';

export interface IGetDatabasesParams extends IGetItemsParams {
}

export interface IGetDatabasesResult extends IGetItemsResult {
  databases?: IDatabase[];
  maxDownstreamDatasourcesViewModel?: IMaxDownstreamDatasources;
  maxDownstreamWorkbooksViewModel?: IMaxDownstreamWorkbooks;
}

export class GetDatabasesRequest extends Request<IGetDatabasesParams, IGetDatabasesResult> {
  constructor(params: IGetDatabasesParams) {
    super('getDatabases', params);
  }
}